import { Rule } from 'rc-field-form/es/interface'

// todo: переисп-ть везде
export const requiredStringRules: Rule[] = [{ required: true, whitespace: true }]
export const onlyNotEmptyStringRules: Rule[] = [{ whitespace: true }]
export const onlyRequiredRules: Rule[] = [{ required: true }]
